import { HiOutlineViewColumns } from 'react-icons/hi2'

export type StageCount = {
  stage: string
  count: number
}

const STAGE_LABELS: Record<string, string> = {
  prospect: 'Prospect',
  in_progress: 'In progress',
  proposal_sent: 'Proposal Sent',
}

type Props = {
  entries: StageCount[]
}

export default function StagesCard({ entries }: Props) {
  const max = Math.max(...entries.map((e) => e.count), 1)

  return (
    <div className="flex flex-col overflow-hidden rounded-xl bg-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_0px_rgba(0,0,0,0.06)]">
      <div className="flex items-center gap-2 border-b border-[#f5f5f5] px-5 py-3">
        <HiOutlineViewColumns className="h-5 w-5 text-ink" aria-hidden="true" />
        <h3 className="font-display text-lg font-medium tracking-tight text-ink">Stages</h3>
      </div>

      <div className="flex flex-col gap-2 px-6 pb-6 pt-4">
        {entries.map((entry) => {
          const widthPct = Math.max((entry.count / max) * 100, 12)
          return (
            <div key={entry.stage} className="relative rounded px-2 py-1.5">
              <div
                className="absolute inset-y-0 left-0 rounded bg-gradient-to-r from-[#93D500]/50 to-[#93D500]/0"
                style={{ width: `${widthPct}%` }}
              />
              <div className="relative flex items-center justify-between">
                <p className="font-display text-sm text-black">{STAGE_LABELS[entry.stage] ?? entry.stage}</p>
                <span className="font-display text-xs font-medium text-black">{entry.count}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
